var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 3H6.83333C5.825 3 5 3.825 5 4.83333V19.5C5 20.5083 5.81583 21.3333 6.82417 21.3333H17.8333C18.8417 21.3333 19.6667 20.5083 19.6667 19.5V8.5L14.1667 3ZM17.8333 19.5H6.83333V4.83333H13.25V9.41667H17.8333V19.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5285 17.5255L14.1739 15.171C14.6205 14.6197 14.8893 13.9187 14.8893 13.1556C14.8893 11.3865 13.4501 9.94727 11.681 9.94727C9.91191 9.94727 8.47266 11.3865 8.47266 13.1556C8.47266 14.9247 9.91193 16.364 11.681 16.364C12.4441 16.364 13.1451 16.0951 13.6964 15.6486L16.0509 18.0031C16.1169 18.069 16.2238 18.069 16.2897 18.0031L16.5285 17.7643C16.5944 17.6984 16.5944 17.5914 16.5285 17.5255Z",
    color: "transparent",
    className: "link-path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.27529c8fc3e3c4cbd66f419be473396d.svg";
export { ForwardRef as ReactComponent };